import React from "react";
import classes from "./NotificationCard.module.css";
import { TagIcon, IncreaseIcon } from "../../constant";

const FooterContent = () => {
  return (
    <div className={classes.footerContent}>
      <span className={classes.stats}>
        <span className={classes.icon}>
          <IncreaseIcon />
        </span>
        <span className={classes.percent}>1.20%</span>
      </span>
      <p className={classes.date}>since last month</p>
    </div>
  );
};
const NotificationCard = ({data}) => {
  console.log("CC",data)
  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <span>
          {data?.icon}
        </span>
        <div>
          <h3 className={classes.no}>{data?.no}</h3>
          <p className={classes.description}>{data?.description}</p>
        </div>
      </div>
      <footer>
        <FooterContent />
      </footer>
    </div>
  );
};

export default NotificationCard;
